import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxInformationListComponent,
  OnyxInformationRowComponent,
} from '@onyx/angular';
import { AmountCellComponent } from '../../../../../common/components/cells/amount-cell/amount-cell.component';
import { ModalDateRowComponent } from '../../../../../common/components/modal-documents/modal-date-row/modal-date-row.component';
import { ModalDocumentsHeadingComponent } from '../../../../../common/components/modal-documents/modal-documents-heading/modal-documents-heading.component';
import { DictionaryCode } from '../../../../../common/enums/dictionary-code';
import { ColorHelper } from '../../../../../common/helpers/color.helper';
import type { Fleet } from '../../../common/interfaces/fleet';

@Component({
  selector: 'app-fleet-modal-documents',
  imports: [
    OnyxInformationRowComponent,
    ModalDocumentsHeadingComponent,
    TranslatePipe,
    ModalDateRowComponent,
    AmountCellComponent,
    OnyxInformationListComponent,
  ],
  templateUrl: './fleet-modal-documents.component.html',
  styleUrl: './fleet-modal-documents.component.scss',
})
export class FleetModalDocumentsComponent {
  public readonly vehicle = input.required<Fleet>();

  protected readonly ColorHelper = ColorHelper;
  protected readonly DictionaryCode = DictionaryCode;
}
